import type { ButtonProps as MUButtonProps } from "@mui/material";
import { Button as MUButton } from "@mui/material";
import type { ReactNode } from "react";
import styled from "styled-components";

import colors from "@/styles/colors";

const ButtonClasses = {
    root: "button-root",
    contained: "button-contained",
};

const StyledButton = styled(MUButton)`
    &&.button-root {
        outline: none;
        border-radius: 24px;
        box-shadow: none;
        height: 35px;
    }
    &&.button-root:focus .button-contained {
        box-shadow: 0 0 4px 2px ${colors.skyHover};
    }
`;

interface ButtonProps extends Omit<MUButtonProps, "variant" | "color"> {
    /**
     * The button content.
     */
    children?: ReactNode;
    /**
     * Whether to use the outlined variant.
     */
    outlined?: boolean;
}

/**
 * Material UI button wrapper supporting contained and outlined variants.
 *
 * @param {ButtonProps} props - The button properties.
 * @returns {ReactNode} The rendered button component.
 */
const Button = ({
    children,
    outlined,
    onClick,
    ...props
}: ButtonProps): ReactNode => (
    <StyledButton
        {...props}
        onClick={onClick}
        variant={outlined ? "outlined" : "contained"}
        color={outlined ? "secondary" : "primary"}
        classes={ButtonClasses}
    >
        {children}
    </StyledButton>
);

export default Button;
